/**
 * utils/phone.ts — the ONE place phone numbers are validated, normalized and
 * formatted. Indian mobile: 10 digits starting 6-9; stored/sent as E.164 (+91…).
 * Everything that touches a phone imports from here — never re-implement the regex.
 */

const IN_MOBILE = /^[6-9]\d{9}$/;

/** Strip to digits; drop a leading 91 (country) or 0 (trunk) so paste/formatting works. */
export function phoneDigits(input: string): string {
  let d = (input || '').replace(/\D/g, '');
  if (d.length === 12 && d.startsWith('91')) d = d.slice(2);
  if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
  return d.slice(0, 10);
}

/** Valid Indian mobile? (10 digits, first 6-9) */
export function isValidMobile(input: string): boolean {
  return IN_MOBILE.test(phoneDigits(input));
}

/** E.164 (+91XXXXXXXXXX) or null when the input isn't a valid mobile. */
export function toE164(input: string): string | null {
  const d = phoneDigits(input);
  return IN_MOBILE.test(d) ? `+91${d}` : null;
}

/** Display form: "+91 98451 27760" (E.164 or raw in; unchanged if not a mobile). */
export function formatPhone(input: string): string {
  const d = phoneDigits(input);
  if (!IN_MOBILE.test(d)) return input || '';
  return `+91 ${d.slice(0, 5)} ${d.slice(5)}`;
}

/** True when the trimmed text is all digits (a phone-ish query, not a name). */
export function looksLikePhone(input: string): boolean {
  return /^\+?\d[\d\s-]*$/.test((input || '').trim());
}
